import { reactive } from 'vue';

export default <T extends Record<string, unknown>>(initialValues: T | (() => T)) => {
  let form: T;
  if (typeof initialValues === 'function') {
    form = reactive<T>({
      ...initialValues(),
    }) as T;
  } else {
    form = reactive<T>({
      ...initialValues,
    }) as T;
  }

  const resetForm = () => {
    if (typeof initialValues === 'function') {
      const customInitialValues = (initialValues as () => T)();
      Object.keys(form).forEach((key) => {
        (form as Record<string, unknown>)[key] = customInitialValues[key];
      });
      return;
    }

    Object.keys(form).forEach((key) => {
      (form as Record<string, unknown>)[key] = initialValues[key];
    });
  };

  return {
    form,
    resetForm,
  };
};
